import axios from "axios";
import fileDownload from 'js-file-download';

export const UPLOAD_FILE = "UPLOAD_FILE";

export const uploadFile = (formData) => (dispatch) => {
    try {
        return axios.post("/upload", formData);

    } catch (error) {
        console.log("ERREUR UPLOAD FILE ", error);
    }
};

export const downloadFile = (name, url) => (dispatch) => {
    try{

        return axios.get(`${process.env.REACT_APP_PROXY}${url}`, {
                            responseType: 'blob',
                        }).then((res) => {
                            fileDownload(res.data, `${name}`);
                        }); 
    } catch (error) {
        console.log("ERREUR ", error);
    }    
}
